import * as auth0 from "auth0-js";
import * as Sentry from "@sentry/react";
import { BaseAuth, AuthResult, AuthError } from './base-auth';
import { AUTH_CONFIG } from "./auth0-variables";
import CONFIG from "Config";
import { Utils } from '../utils';

export class Auth0Auth extends BaseAuth {
  private auth0Client: any;

  constructor() {
    super();
    this.auth0Client = new auth0.WebAuth({
      domain: AUTH_CONFIG.domain,
      clientID: AUTH_CONFIG.clientId,
      redirectUri: `${location.protocol}//${location.host}/callback`,
      responseType: "token id_token",
      scope: "openid profile email",
    });
  }

  login = (username: string, password: string, onError: (err: AuthError) => void) => {
    const wrappedOnError = (err: any) => {
      if (err.description == 'Wrong email or password.'){
        this.EAIClient.logBadLogin(username);
        onError(err);
      }
    };

    this.EAIClient.logLogin(username);
    this.auth0Client.login({
      username,
      password,
      realm: AUTH_CONFIG.authDatabase,
    }, wrappedOnError);
  };

  loginRedirect() {
    const postRedirect = localStorage.getItem("post_login_redirect");
    if (location.pathname !== "/callback" && !location.pathname.includes("/login") && location.pathname !== postRedirect) {
      localStorage.setItem("post_login_redirect", `${location.pathname}${location.search}`);
    }
    if (location.pathname !== "/login" && location.pathname !== "/callback" && location.pathname !== "/activate" && location.pathname !== "clearstorage") {
      window.location.href = CONFIG.paths.base + "login";
    }
  }

  authorizeSSOConnection = (connection: string) => {
    this.auth0Client.authorize({connection: connection});
  };

  resetPassword(email: string, onError: (err: AuthError) => void, onSuccess: (resp: any) => void) {
    this.auth0Client.changePassword({
      connection: AUTH_CONFIG.authDatabase,
      email,
    }, (err: any, resp: any) => {
      if (err) {
        onError(err);
      } else {
        onSuccess(resp);
      }
    });
  }

  handleAuthentication = () => {
    this.auth0Client.parseHash((err: any, authResult: any) => {
      if(err && err.error === "unauthorized" || !authResult){
        let errorMessage = "Authentication Result Invalid";
        if (err && err.errorDescription) {
          errorMessage = err.errorDescription;
        }
        localStorage.setItem("authentication_error", errorMessage);
        Sentry.addBreadcrumb({
          message: errorMessage,
          data: { err },
        });
        return location.replace(CONFIG.paths.base + "login");
      }
      
      const authResultTyped: AuthResult = {
        idToken: authResult.idToken,
        accessToken: authResult.accessToken,
        expiresIn: authResult.expiresIn
      };
      
      this.handleAuthSuccess(authResultTyped);
    });
  };

  handleLogout = (callback: () => void) => {
    this.EAIClient.logOut().then(() => {
      Utils.clearLocalstorage();
      callback();
    });
  };
} 